import './App.css';
import formsDGT from './forms_dgt.json';
import provincias from './provincias.json';
import { MenuProps, verificaNIF} from "./utils";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import {
    Checkbox,
    Input,
    MenuItem,
    Select,
    Button,
    NativeSelectRoot,
    NativeSelectField, Field
} from "@chakra-ui/react";
import * as React from 'react'
import { useNavigate } from 'react-router-dom';
import {FormControlLabel, Radio, RadioGroup} from "@mui/material";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import { es } from 'date-fns/locale/es';

function App() {
    let navigate = useNavigate();
    const [selectedValue, setSelectedValue] = React.useState('');
    const [selectedProvinceValue, setSelectedProvinceValue] = React.useState('');
    const [formData, setFormData] = React.useState({"Provincia cita": ""});
    const [mandatoryFormData, setmandatoryFormData] = React.useState([]);
    const [showResidencia, setShowResidencia] = React.useState(false);
    const [addCita, setAddCita] = React.useState(false);
    const [datePickerEnabled, setdatePickerEnabled] = React.useState(false);
    const [allMandatoryFilled, setallMandatoryFilled] = React.useState(false);
    const [startDate, setStartDate] = React.useState(new Date());
    var current_date = new Date();
    const [endDate, setEndDate] = React.useState(new Date(current_date.getFullYear(), current_date.getMonth(), current_date.getDate() + 180));
    const [certificateFile, setCertificateFile] = React.useState(null);
    registerLocale('es', es)

    const pemPublicKey = `
	-----BEGIN PUBLIC KEY-----
	MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAmPBQf3n51xedWXL90yCr
	PLeqqZmcYnPiBHfp4URTFK4IQZQu9PSbKGQqroMqNXJ8KQM9S9POnh+xQCJuMRls
	GxMgDWuyS0/rtGyavlHo5twR4TkPCxP8S7zAG5XngEJHy04sMxzx6j7QteAKTtYF
	G/dtVDHkjtjzvzz+Zd0J6OpPPBaR+mywNO7XW85JmVjvQGb6erPQSKB2MhFH1WiZ
	CWw2A6sEoGAQIwwfAyNMeCkXLfLbpru55MR3qewjQiISuck0aiAYlYKURmC99Ryg
	pnQFAegzBgSrjuSHmLat75JZpTXCdQxkZfzPue/d8wYhbLCFcw1oMm+R2LcILyCr
	bwIDAQAB
	-----END PUBLIC KEY-----
	`

    const [importedPublicKey, setImportedPublicKey] = React.useState(null);

    function decodeBase64ToUtf8(base64String) {
        // Decode the Base64 string
        let decodedString = atob(base64String);

        // Convert the decoded string to a UTF-8 string
        let utf8String = decodeURIComponent(escape(decodedString));

        return utf8String;
    }

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setCertificateFile(selectedFile);
    };

    React.useEffect(() => {
        setPaisCanje();
    }, []);

    const toBase64 = (file) => {
        const reader = new FileReader();

        return new Promise((resolve, reject) => {
            reader.onload = () => resolve(reader.result.split(",")[1]); // Extract only Base64 part
            reader.onerror = (error) => reject(error);
            reader.readAsDataURL(file);
        });
    };

    const decodeJwtPayload = (token) => {
        const parts = token.split(".");
        if (parts.length !== 3) {
            throw new Error("Invalid JWT format");
        }

        const payloadBase64 = parts[1];
        const decodedPayload = atob(payloadBase64);
        return JSON.parse(decodedPayload);
    };

    const setPaisCanje = async () => {
        const pemHeader = "-----BEGIN PUBLIC KEY-----";
        const pemFooter = "-----END PUBLIC KEY-----";
        const pemContents = pemPublicKey.trim().replace(pemHeader, "").replace(pemFooter, "");
        const binaryDerString = atob(pemContents);
        const binaryDer = str2ab(binaryDerString);

        setImportedPublicKey(await crypto.subtle.importKey(
            "spki",
            binaryDer,
            {
                name: "RSA-OAEP",
                hash: "SHA-256",
            },
            true,
            ["encrypt"]
        ));

        const defaultData = {"documento": "", "nombre": "", "txtAnnoCitado": "", "numero": "", "correo": "", "txtUsuarioClave": "", "txtPassClave": "", "txtPassCertificado": "", "txtPaisNac": ""};
        const defaultMandatoryData = ["documento", "nombre", "txtAnnoCitado", "numero", "correo", "txtPaisNac"];

        const token = searchParams.get("token")
        const payload = decodeJwtPayload(token)

        console.log(payload)

        defaultData["fechaMin"] = startDate.toLocaleDateString('en-GB')
        defaultData["fechaMax"] = endDate.toLocaleDateString('en-GB')
        defaultData["Observaciones"] = ""
        defaultData["token"] = token
        defaultData["tipo_bot"] = "RC_SEDE"
        defaultData["tipoCita"] = "RC_SEDE"
        defaultData["pageType"] = "RC_SEDE"
        defaultData["source"] = "TELEGRAM"
        defaultData["client_email"] = ""
        defaultData["timePreference"] = "any"
        defaultData["codTramite"] = payload["tramite"]
        defaultData["codOficina"] = payload["oficina"] + ""
        defaultData["oficinas"] = payload["oficina"] + ""
        defaultData["price"] = payload["price"]
        defaultData["tguser_id"] = payload["tguser_id"]
        defaultData["rdbTipoDoc"] = "N.I.E."
        defaultData["txtPassCertificado"] = ""
        defaultData["txtUsuarioClave"] = ""
        defaultData["txtPassClave"] = ""
        setFormData(defaultData);
        setmandatoryFormData(defaultMandatoryData);
    }

    const str2ab = (str) => {
        const buf = new ArrayBuffer(str.length);
        const bufView = new Uint8Array(buf);
        for (let i = 0; i < str.length; i++) {
            bufView[i] = str.charCodeAt(i);
        }
        return buf;
    }

    const encryptString = async (publicKey, data) => {
        const encodedData = str2ab(data);
        const encryptedData = await crypto.subtle.encrypt(
            {
                name: "RSA-OAEP",
            },
            publicKey,
            encodedData
        );
        return encryptedData;
    }

    const arrayBufferToBase64 = (buffer) => {
        let binary = '';
        const bytes = new Uint8Array(buffer);
        for (let i = 0; i < bytes.byteLength; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return btoa(binary);
    }

    const handleSubmit = async () => {
        if (validateForm()) {
            // For now, just log the data. In real scenarios, you'd send this to a server.
            console.log(formData);
            if (certificateFile != null) {
                const fileContent = await toBase64(certificateFile);
                formData["certificate_data"] = fileContent
            } else {
                formData["certificate_data"] = ""
            }

            if (formData["txtPassCertificado"] !== "") {
                console.log(importedPublicKey)
                const encryptedData = await encryptString(importedPublicKey, formData["txtPassCertificado"]);
                formData["txtPassCertificado"] = arrayBufferToBase64(encryptedData);
            }

            if (formData["txtPassClave"] !== "") {
                const encryptedData = await encryptString(importedPublicKey, formData["txtPassClave"]);
                formData["txtPassClave"] = arrayBufferToBase64(encryptedData);
            }

            fetch('https://api.notifybotstg.com/api/pro/new_appointment', {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
                //.then(response => response.text())
                .then(data => {
                    console.log('Success:', data);
                    navigate('success');
                })
                .catch((error) => {
                    console.error('Error:', error);
                    navigate('error');
                });
        }
    };

    const validateForm = () => {
        var fulfilled = true;
        console.log(formData)

        if (formData["txtPaisNac"] === "Seleccionar") {
            fulfilled = false
        }

        mandatoryFormData.forEach(field => {
            console.log(field)
            if ((formData[field] === '') || (Array.isArray(formData[field]) && formData[field].length == 0)) {
                fulfilled = false;
                setallMandatoryFilled(true)
            }
        });

        fulfilled = fulfilled && (formData["rdbTipoDoc"] === "PASAPORTE" || verificaNIF(formData["documento"]));

        return fulfilled;
    };

    const handleDropdownChange = (event) => {
        //setShowResidencia(true);
        const defaultData = {};
        const defaultMandatoryData = [];
        formsDGT[event.target.value].forEach(field => {
            defaultData[field.name] = field.type === "select" ? '' : '';
            //defaultData[field.name] = field.type === "select" ? field.options[0] : '';
            if (field.mandatory) {
                defaultMandatoryData.push(field.name)
            }
        });
        defaultMandatoryData.push("País de nacionalidad")
        defaultMandatoryData.push("Provincia cita")
        defaultData["Provincia cita"] = ""
        defaultData["fechaMin"] = startDate.toLocaleDateString('en-GB')
        defaultData["fechaMax"] = endDate.toLocaleDateString('en-GB')
        defaultData["txtObservaciones"] = ""
        defaultData["Pais"] = event.target.value
        setFormData(defaultData);
        setmandatoryFormData(defaultMandatoryData);
        if (event.target.value == "Seleccionar...") {
            setAddCita(false);
        } else {
            setAddCita(true);
        }
        setSelectedValue(event.target.value);
    };

    const handleInputChange = (event) => {
        console.log(event)

        setFormData({
            ...formData,
            [event.target.name]: event.target.type === 'checkbox' ? event.target.checked : event.target.value.trimStart()
        });
    };

    const searchParams = new URLSearchParams(document.location.search)

    const [tipoDoc, setTipoDoc] = React.useState('N.I.E.');

    return (
        <div>
            <div className="form">
                <div className="grid-container">
                    <div key="rdbTipoDoc" className="input-wrapper">
                        <label>Tipo de documento<b style={{color: 'red'}}>{" *"}</b></label>
                        <RadioGroup
                            name="rdbTipoDoc"
                            value={tipoDoc}
                            onChange={(newValue) => {
                                setTipoDoc(newValue.target.value)
                                formData["rdbTipoDoc"] = newValue.target.value
                            }}
                        >
                            <FormControlLabel value="N.I.E." control={<Radio/>} label="N.I.E."/>
                            <FormControlLabel value="PASAPORTE" control={<Radio/>} label="PASAPORTE"/>
                            <FormControlLabel value="D.N.I." control={<Radio/>} label="D.N.I."/>
                        </RadioGroup>
                    </div>
                    <div key="documento" className="input-wrapper">
                        <label>Número de documento<b style={{color: 'red'}}>{" *"}</b></label>
                        <Field.Root invalid={formData["documento"] !== undefined && !(formData["rdbTipoDoc"] === "PASAPORTE" || verificaNIF(formData["documento"]))}>
                            <Input
                                name="documento"
                                type="text"
                                value={formData["documento"] || ''}
                                onChange={handleInputChange}
                                placeholder=''
                            />
                            <Field.ErrorText>Introduce un documento valido</Field.ErrorText>
                        </Field.Root>
                    </div>
                    <div key="nombre" className="input-wrapper">
                        <label>Nombre y apellidos<b style={{color: 'red'}}>{" *"}</b></label>
                        <Input
                            name="nombre"
                            type="text"
                            value={formData["nombre"] || ''}
                            onChange={handleInputChange}
                            placeholder=''
                        />
                    </div>
                    <div key="txtAnnoCitado" className="input-wrapper">
                        <label>Año de nacimiento<b style={{color: 'red'}}>{" *"}</b></label>
                        <Input
                            name="txtAnnoCitado"
                            type="number"
                            value={formData["txtAnnoCitado"] || ''}
                            onChange={handleInputChange}
                            placeholder=''
                        />
                    </div>
                    <div id="txtPaisNac" className="input-wrapper"
                                     style={{display: showResidencia ? "none" : "flex"}}>
                        <label>País de nacionalidad <b style={{color: 'red'}}> *</b></label>
                        <NativeSelectRoot size="sm" width="240px" name="txtPaisNac"
                                          value={selectedProvinceValue} onChange={handleInputChange}>
                            <NativeSelectField name="txtPaisNac">
                                <option key="Seleccionar" value="Seleccionar">Seleccionar</option>
                                {provincias.map(opt => (
                                    <option name="txtPaisNac" key={opt} value={opt}>{opt}</option>
                                ))}
                            </NativeSelectField>
                        </NativeSelectRoot>
                    </div>
                    <div key="numero" className="input-wrapper">
                        <label>Teléfono<b style={{color: 'red'}}>{" *"}</b></label>
                        <Field.Root invalid={formData["numero"] && (formData["numero"].length < 9 && formData["numero"].length > 0)}>
                            <Input
                                name="numero"
                                type="tel"
                                value={formData["numero"] || ''}
                                onChange={handleInputChange}
                                placeholder=''
                                minLength={9}
                                maxLength={9}
                            />
                            <Field.ErrorText>Introduce un teléfono valido</Field.ErrorText>
                        </Field.Root>
                    </div>
                    <div key="correo" className="input-wrapper">
                        <label>Correo electrónico<b style={{color: 'red'}}>{" *"}</b></label>
                        <Input
                            name="correo"
                            type="email"
                            value={formData["correo"] || ''}
                            onChange={handleInputChange}
                            placeholder=''
                        />
                    </div>
                    <div id="fechaMin" className="input-wrapper"
                                     style={{display: showResidencia ? "none" : "flex"}}>
                        <label>Buscar fecha a partir del</label>
                        <DatePicker
                            showIcon
                            selected={startDate}
                            onSelect={(date) => setStartDate(date)}
                            onChange={(date) => {
                                var event = {
                                    "target": {
                                        "name": "fechaMin",
                                        "value": date.toLocaleDateString('en-GB'),
                                        "type": "datepicker"
                                    }
                                };
                                handleInputChange(event)
                            }}
                            onChangeRaw={event => {
                                const date = moment(event.target.value, "DD/MM/YYYY");
                                if (date.isValid()) {
                                    setStartDate(date.toDate());
                                }
                            }}
                            name="fechaMin"
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            locale="es"
                        />
                    </div>
                    <div id="fechaMax" className="input-wrapper"
                                     style={{display: showResidencia ? "none" : "flex"}}>
                        <label>Hasta el día</label>
                        <DatePicker
                            showIcon
                            selected={endDate}
                            onSelect={(date) => setEndDate(date)}
                            onChange={(date) => {
                                var event = {
                                    "target": {
                                        "name": "fechaMax",
                                        "value": date.toLocaleDateString('en-GB'),
                                        "type": "datepicker"
                                    }
                                };
                                handleInputChange(event)
                            }}
                            onChangeRaw={event => {
                                const date = moment(event.target.value, "DD/MM/YYYY");
                                if (date.isValid()) {
                                    setEndDate(date.toDate());
                                }
                            }}
                            name="fechaMax"
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            minDate={startDate}
                            locale="es"
                        />
                    </div>
                    <div id="txtObservaciones" className="input-wrapper"
                                     style={{display: showResidencia ? "none" : "flex", paddingBottom: "10px"}}>
                        <label>Observaciones</label>
                        <Input
                            name={"txtObservaciones"}
                            type="text"
                            value={formData["txtObservaciones"] || ''}
                            onChange={handleInputChange}
                            placeholder={""}
                        />
                    </div>
                    <Button style={{width: "100%"}} class="sendButton" variant="contained" color="primary"
                                        onClick={handleSubmit}
                    >Enviar solicitud</Button>
                </div>
                {allMandatoryFilled && <p>Rellena todos los campos obligatorios *</p>}
                <div></div>
            </div>
        </div>
    );
}

export default App;
